import http from "../httpService";

const apiEndpoint = "/report/work";


export function getReportWorkItem(id) {
  return http.get(apiEndpoint + '/' + id)
}

